module.exports = __webpack_public_path__ + "img/summer.d17b52ee.svg";